var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShampooSvgrepocom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_295_880)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.0552 6.16657H15.1023V4.39536C15.1023 3.95356 14.7441 3.59534 14.3023 3.59534H12.8V1.5995H15.6203C16.0071 1.5995 16.3219 1.91421 16.3219 2.30103C16.3219 2.74282 16.68 3.10104 17.1219 3.10104C17.5637 3.10104 17.9219 2.74287 17.9219 2.30107C17.9219 1.03203 16.8894 -0.000488281 15.6203 -0.000488281H12C11.5582 -0.000488281 11.2 0.357684 11.2 0.799527V3.59539H9.698C9.2562 3.59539 8.89798 3.95356 8.89798 4.3954V6.16662H7.94506C6.32764 6.16662 5.01172 7.4825 5.01172 9.09997V23.1996C5.01172 23.6414 5.36989 23.9996 5.81173 23.9996H18.1885C18.6303 23.9996 18.9885 23.6414 18.9885 23.1996V9.09987C18.9885 7.48245 17.6727 6.16657 16.0552 6.16657ZM10.4981 5.19537H13.5023V6.16657H10.4981V5.19537ZM17.3885 22.3995H6.6118V9.09987C6.6118 8.36468 7.20992 7.76656 7.94511 7.76656C9.82123 7.76656 14.4639 7.76656 16.0552 7.76656C16.7904 7.76656 17.3885 8.36468 17.3885 9.09987L17.3885 22.3995Z",
    fill: "#9393B0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.4552 9.8999H9.54513C9.10334 9.8999 8.74512 10.2581 8.74512 10.6999V19.4662C8.74512 19.908 9.10329 20.2662 9.54513 20.2662H14.4552C14.897 20.2662 15.2552 19.908 15.2552 19.4662V10.6999C15.2552 10.2581 14.897 9.8999 14.4552 9.8999ZM13.6552 18.6662H10.3451V11.4999H13.6552V18.6662Z",
    fill: "#9393B0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_295_880"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShampooSvgrepocom);
export default __webpack_public_path__ + "static/media/shampoo_svgrepo.com.473cd7521e16916cddb24ddb84d7b292.svg";
export { ForwardRef as ReactComponent };